import { SVGProps } from 'react';

const Route = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0m0 0h8.5a3.5 3.5 0 1 0 0-7h-11a3.5 3.5 0 1 1 0-7H15m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0"
    />
  </svg>
);
export default Route;
